// Generated by ReScript, PLEASE EDIT WITH CARE


function reducer(state, action) {
  switch (action.TAG | 0) {
    case /* CustomerAndPartnerDetails */0 :
        return {
                customerAndPartnerDetails: action.customerAndPartnerDetails,
                previouslySentMessagesDetails: state.previouslySentMessagesDetails,
                userTypeSelection: state.userTypeSelection,
                phoneNumber: state.phoneNumber,
                selectUser: state.selectUser,
                showSidePanel: state.showSidePanel,
                selectedUser: state.selectedUser,
                confirmationModal: state.confirmationModal,
                resendSmsDetails: state.resendSmsDetails,
                currentView: state.currentView,
                enableEditTemplate: state.enableEditTemplate
              };
    case /* PreviouslySentMessagesDetails */1 :
        return {
                customerAndPartnerDetails: state.customerAndPartnerDetails,
                previouslySentMessagesDetails: action.previouslySentMessagesDetails,
                userTypeSelection: state.userTypeSelection,
                phoneNumber: state.phoneNumber,
                selectUser: state.selectUser,
                showSidePanel: state.showSidePanel,
                selectedUser: state.selectedUser,
                confirmationModal: state.confirmationModal,
                resendSmsDetails: state.resendSmsDetails,
                currentView: state.currentView,
                enableEditTemplate: state.enableEditTemplate
              };
    case /* UserTypeSelection */2 :
        return {
                customerAndPartnerDetails: state.customerAndPartnerDetails,
                previouslySentMessagesDetails: state.previouslySentMessagesDetails,
                userTypeSelection: action.userTypeSelection,
                phoneNumber: state.phoneNumber,
                selectUser: state.selectUser,
                showSidePanel: state.showSidePanel,
                selectedUser: state.selectedUser,
                confirmationModal: state.confirmationModal,
                resendSmsDetails: state.resendSmsDetails,
                currentView: state.currentView,
                enableEditTemplate: state.enableEditTemplate
              };
    case /* PhoneNumber */3 :
        return {
                customerAndPartnerDetails: state.customerAndPartnerDetails,
                previouslySentMessagesDetails: state.previouslySentMessagesDetails,
                userTypeSelection: state.userTypeSelection,
                phoneNumber: action.phoneNumber,
                selectUser: state.selectUser,
                showSidePanel: state.showSidePanel,
                selectedUser: state.selectedUser,
                confirmationModal: state.confirmationModal,
                resendSmsDetails: state.resendSmsDetails,
                currentView: state.currentView,
                enableEditTemplate: state.enableEditTemplate
              };
    case /* SelectUser */4 :
        return {
                customerAndPartnerDetails: state.customerAndPartnerDetails,
                previouslySentMessagesDetails: state.previouslySentMessagesDetails,
                userTypeSelection: state.userTypeSelection,
                phoneNumber: state.phoneNumber,
                selectUser: action.selectUser,
                showSidePanel: state.showSidePanel,
                selectedUser: state.selectedUser,
                confirmationModal: state.confirmationModal,
                resendSmsDetails: state.resendSmsDetails,
                currentView: state.currentView,
                enableEditTemplate: state.enableEditTemplate
              };
    case /* SetSelectedUser */5 :
        return {
                customerAndPartnerDetails: state.customerAndPartnerDetails,
                previouslySentMessagesDetails: state.previouslySentMessagesDetails,
                userTypeSelection: state.userTypeSelection,
                phoneNumber: state.phoneNumber,
                selectUser: state.selectUser,
                showSidePanel: state.showSidePanel,
                selectedUser: action.selectedUser,
                confirmationModal: state.confirmationModal,
                resendSmsDetails: state.resendSmsDetails,
                currentView: state.currentView,
                enableEditTemplate: state.enableEditTemplate
              };
    case /* ShowSidePanel */6 :
        return {
                customerAndPartnerDetails: state.customerAndPartnerDetails,
                previouslySentMessagesDetails: state.previouslySentMessagesDetails,
                userTypeSelection: state.userTypeSelection,
                phoneNumber: state.phoneNumber,
                selectUser: state.selectUser,
                showSidePanel: action.showSidePanel,
                selectedUser: state.selectedUser,
                confirmationModal: state.confirmationModal,
                resendSmsDetails: state.resendSmsDetails,
                currentView: state.currentView,
                enableEditTemplate: state.enableEditTemplate
              };
    case /* SetModalState */7 :
        return {
                customerAndPartnerDetails: state.customerAndPartnerDetails,
                previouslySentMessagesDetails: state.previouslySentMessagesDetails,
                userTypeSelection: state.userTypeSelection,
                phoneNumber: state.phoneNumber,
                selectUser: state.selectUser,
                showSidePanel: state.showSidePanel,
                selectedUser: state.selectedUser,
                confirmationModal: {
                  modal: action.modal,
                  openModal: action.openModal
                },
                resendSmsDetails: state.resendSmsDetails,
                currentView: state.currentView,
                enableEditTemplate: state.enableEditTemplate
              };
    case /* SetResendSMSDetails */8 :
        return {
                customerAndPartnerDetails: state.customerAndPartnerDetails,
                previouslySentMessagesDetails: state.previouslySentMessagesDetails,
                userTypeSelection: state.userTypeSelection,
                phoneNumber: state.phoneNumber,
                selectUser: state.selectUser,
                showSidePanel: state.showSidePanel,
                selectedUser: state.selectedUser,
                confirmationModal: state.confirmationModal,
                resendSmsDetails: action.resendSmsDocument,
                currentView: state.currentView,
                enableEditTemplate: state.enableEditTemplate
              };
    case /* SetCurrentView */9 :
        return {
                customerAndPartnerDetails: state.customerAndPartnerDetails,
                previouslySentMessagesDetails: state.previouslySentMessagesDetails,
                userTypeSelection: state.userTypeSelection,
                phoneNumber: state.phoneNumber,
                selectUser: state.selectUser,
                showSidePanel: state.showSidePanel,
                selectedUser: state.selectedUser,
                confirmationModal: state.confirmationModal,
                resendSmsDetails: state.resendSmsDetails,
                currentView: action.currentView,
                enableEditTemplate: state.enableEditTemplate
              };
    
  }
}

export {
  reducer ,
  
}
/* No side effect */
